<!--src/app/pages/profile/profile.component.html-->
<!--<div>
  <form #profileForm="ngForm" (ngSubmit)="onSubmit(profileForm.value)">
    <div class="card card-secondary">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h4 class="card-title w-100">
          <span>Profile Settings For: {{profile.emailAddress}}</span>
        </h4>-->
        <!--<a (click)="unlinkAgent()" class="btn btn-dark rounded-pill btn-sm" ngbTooltip="Unlink Your Agent IDs" tooltipClass="lbig-tooltip">Unlink&nbsp;IDs</a>-->
      <!--</div>
      <div class="card-body box-profile">
        <div class="form-group">
          <label>My Linked Agent IDs</label>
          <app-agentgrid></app-agentgrid>
        </div>
        <div class="form-group">
          <label>Display Name</label>
          <input class="form-control" name="displayName" [(ngModel)]="displayName" [value]="displayName">
        </div>
      </div>
      <div class="card-footer">
        <div class="text-center">
          <input type="submit" class="btn btn-secondary input-block-level" value="Save Changes">
        </div>
      </div>
    </div>
  </form>
</div>-->

<!-- Assistant Invitation List Addition (in progress) -->
<!--<div class="nav-container mb-1">
  <nav class="navbar navbar-expand-md navbar-light bg-light">
    <div class="container-fluid justify-content-center">
      <ul class="nav navbar-nav" id="menu">
        <li class="nav-item">
          <a class="nav-link router-link-exact-active" id="LinkedAgents-tab" data-toggle="tab" href="#LinkedAgents">Linked IDs</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="AssistAccessList-tab" data-toggle="tab" href="#AssistAccessList">Assistant Access</a>
        </li>
      </ul>
    </div>
  </nav>
</div>
<br />-->

<!-- Tab panes -->
<div class="tab-content clearfix" id="tabPanes">
  <div class="tab-pane active" id="LinkedAgents">
    <app-linked-agents></app-linked-agents>
  </div>

  <!-- Assistant Access List Addition (in progress) -->
  <!--<div class="tab-pane" id="AssistAccessList">
    <app-assistant-access></app-assistant-access>
  </div>-->

</div>
